// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const SupplierOwnerService = {};

SupplierOwnerService.addtSupplerBankAcc = function (data) {
  
  return lossClient({
    url: "/SupplierBankAccount/add",
    method: "post",
    data: {
      SupplierID: data.SupplierId,
      BankAccounts: data.data.SupplierBabkAcc,
      UserId: data.UserId,
    },
  });
};

export default SupplierOwnerService;
